<template>
  <div :class="['payment-card-wrapper', `payment-card--${item.slug}`]" v-if="item.value">
    <input
      ref="input"
      type="radio"
      @change="change"
      :value="item.method"
      :id="item.id"
      name="payment"
      :disabled="disabled"
      :class="{ 'is-selected': selected }"
    />
    <div class="payment-card">
      <div class="payment-card-header">
        <h3 class="payment-card-header__title">{{ item.type }}</h3>
      </div>

      <div class="payment-card-content">
        <font-awesome-icon class="payment-card-icon" :icon="item.slug" />

        <div class="payment-card-value">
          <h4 class="payment-card-value__title" v-html="valueFormatted"></h4>
          <p class="payment-card-value__description">{{ item.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormPaymentCard',
  props: ['item', 'disabled', 'selected'],
  mounted() {
    if (this.selected) {
      this.change();
    }
  },
  methods: {
    change() {
      this.$emit('change', this.item);
    }
  },
  computed: {
    valueFormatted() {
      const installments = sessionStorage.credit_card_installments || 1;
      const value = this.item.value ? Number(this.item.value.replace(',', '.')) : 0;
      const installmentValue = (value / installments).toFixed(2).replace('.', ',');

      if (this.item.method === 'credit_card') {
        return `<small>até ${installments}x de R$</small> ${installmentValue}`;
      }

      if (this.item.discountedValue) {
        return `<small>R$</small> ${this.item.discountedValue} <small>no 1º mês (R$ ${this.item.value} nos seguintes)</small>`;
      }

      return `<small>R$</small> ${this.item.value}`;
    }
  }
};
</script>

<style lang="scss">
.payment-card-wrapper {
  position: relative;
  width: 100%;
  user-select: none;

  &:not(:last-child) {
    margin-bottom: 24px;

    @media (min-width: 768px) {
      margin-right: 16px;
      margin-bottom: 0;
    }
  }

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;

    &:disabled {
      cursor: default;

      + .payment-card {
        cursor: default;
      }
    }

    &:checked + .payment-card,
    &.is-selected + .payment-card {
      border-color: var(--color-balanced);

      @media (min-width: 768px) {
        transform: translateY(-8px);
        box-shadow: 0 8px 24px rgba(var(--color-balanced-rgb), 0.2);
      }

      .payment-card-header {
        background-color: var(--color-balanced);
      }

      .payment-card-icon,
      .payment-card-value__title,
      .payment-card-value__description {
        color: var(--color-balanced);
      }
    }
  }
}

.payment-card {
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
  height: 260px;
  transition: 0.2s all ease;
  border: 2px solid var(--color-positive-normal);
  text-align: center;
  overflow: hidden;

  &-header {
    padding: 8px;
    background-color: var(--color-positive-normal);
    transition: 0.2s all ease;

    &__title {
      margin: 0;
      color: var(--color-white);
      font-size: 16px;
      line-height: 24px;
    }
  }

  &-content {
    padding: 24px;
  }

  &-icon {
    margin-bottom: 16px;
    font-size: 64px;
    color: var(--color-positive-normal);
  }

  &-value {
    &__title {
      margin: 0;
      font-size: 30px;
      font-weight: 700;
      color: var(--color-positive-normal);

      small {
        font-size: 13px;
      }
    }

    &__description {
      margin: 8px auto 0;
      font-weight: 600;
      font-size: 13px;
      color: var(--color-positive-normal);
    }
  }
}
</style>
